import { useEffect, useState } from "react";

/**
 * Debounced verzia hodnoty — UI píše svižne, ale search/filter sa
 * triggeruje až po `delay` ms ticha.
 *
 * Príklad::
 *
 *   const [search, setSearch] = useState("");
 *   const debouncedSearch = useDebounce(search, 300);
 *   const query = useZakazkyList({ search: debouncedSearch });
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);

  return debounced;
}
